// ImportDetailsModal.tsx
import React from 'react';
import { Box, Typography, Modal, Paper, IconButton, Chip, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { startCase } from 'lodash';
import { formatDataImportStatus, dataImportStatusColorMap } from './ImportHistoryTable';
import { format } from 'date-fns';
import { CustomDataImportSelectItem } from '../graphqlQueries';

interface ImportDetailsModalProps {
  open: boolean;
  onClose: () => void;
  selectedImport: CustomDataImportSelectItem | null;
}

const ImportDetailsModal: React.FC<ImportDetailsModalProps> = ({ open, onClose, selectedImport }) => {

  const getMetadata = () => {
    if (selectedImport?.metadata) {
      try {
        return JSON.parse(selectedImport.metadata);
      } catch (err) {
        return {};
      }
      
    }
    return {};
  }

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="import-details-title">
      <Paper
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          padding: 3,
          outline: 'none',
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" id="import-details-title">
            Imported {selectedImport?.createdAt && format(new Date(selectedImport.createdAt), "MMMM dd, yyyy 'at' hh:mm a")} by {`${selectedImport?.createdBy?.firstName} ${selectedImport?.createdBy?.lastName}`}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Chip
          label={selectedImport && startCase(formatDataImportStatus(selectedImport))}
          color={selectedImport?.status ? dataImportStatusColorMap[formatDataImportStatus(selectedImport)] as 'warning' | 'success' | 'error' : 'default'}
          sx={{ color: 'white', fontWeight: 'bold', marginY: 2 }}
        />

        <List>
          <ListItem>
            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
            {selectedImport?.metadata && <ListItemText primary={`${(getMetadata())?.created_count ?? '-'} Created`} />}
          </ListItem>
          <ListItem>
            <ListItemIcon><CheckCircleIcon color="success" /></ListItemIcon>
            {selectedImport?.metadata && <ListItemText primary={`${(getMetadata())?.updated_count ?? '-'} Updated`} />}
          </ListItem>
        </List>

        {getMetadata()?.errors?.length > 0 && (
          <Box sx={{ padding: 2, borderRadius: 1, marginTop: 2, overflowY: 'scroll', maxHeight: '450px' }}>
            <Typography variant="subtitle2" color="error" fontWeight="bold" gutterBottom>
              Errors
            </Typography>
            {getMetadata()?.errors?.map((err: string) => {
              return (
                <Typography key={err} variant="body2" color="textSecondary">{err}</Typography>
              )
            })}
          </Box>
        )}
      </Paper>
    </Modal>
  );
};

export default ImportDetailsModal;
